<template>
  <table-column-manager model-type="Applicant" />
</template>
<script>
import TableColumnManager from '@/views/borrows/_components/TableColumnManager'

export default {
  name: 'SwitchTableColumn',
  components: { TableColumnManager }
}
</script>
